
import { Box, Container } from "@mui/material";
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
// import { useSelector } from 'react-redux';


interface MenuState {
  solicitacoesImportacao: number;
  analisado: number;
  deferido: number;
  certificadosEmitidos: number;
  reclamacoes: number;
}
type MenuProps = {
  styles: string
}

export default function MenuImportacao({ styles }: MenuProps) { 
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    solicitacoesImportacao: 0,
    // solicitacoesDesalfandegamento: 0,
    reclamacoes: 0,
    analisado: 0,
    deferido: 0,
    certificadosEmitidos: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)

  useEffect(() => {
    api.get(`/menu/dmts`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
      <Container>
        <RegisterAccess page={'menu importação'} />

        <Box className={styles}>
          <CardServices funcao='Técnico'  load={loadMenu} count={menu.solicitacoesImportacao} icone={'/icones/Import_export.svg'} nomeService={'Solicitaçōes de Importaçao '} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Análise'} />
          <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} />
        </Box>

        <Box className={styles}>
          {/* <CardServices load={loadMenu} count={menu.analisado} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Área de Controle de Mercado'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/chefe-de-area-de-inspeccao-regulatoria'} /> */}
          <CardServices load={loadMenu} count={menu.analisado} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Adjunta área técnica'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Analisado'} />
          <CardServices funcao='Chefe de Departamento'  load={loadMenu} count={menu.deferido} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Deferimento'} />
          <CardServices funcao='' load={loadMenu} count={menu.certificadosEmitidos} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados Emitidos'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Não Controlados/Aprovado'} />
          {/* <CardServices load={loadMenu} count={menu.solicitacoesImportacao} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/director-geral/solicitacoes-de-licenciamento'} /> */}
        </Box>
      </Container>
  )
}








